import { APIFunctionNames, COOKIE_SET } from "../api/APIFunctionName";
import { APIInputData } from "../api/APIInputData";
import { APIRequest } from "../api/APIRequest";
import { PHPResponse } from "../PHPResponse";


export class CookieSetInput extends APIInputData
{ 
  name:string;
  value:string;
}

export class CookieSetRequest extends APIRequest<COOKIE_SET,CookieSetInput,PHPResponse>
{
  constructor() { super( APIFunctionNames.COOKIE_SET ); }
}